import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhoneService } from 'src/app/shared/services/phone.service';

@Component({
  selector: 'app-imei-check',
  templateUrl: './imei-check.component.html',
  styleUrls: ['./imei-check.component.scss'],
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate('300ms ease-in')),
      transition('true => false', animate('300ms ease-out'))
    ])
  ]
})
export class ImeiCheckComponent implements OnInit {

  imei = new FormControl('', [Validators.required]);
  collapsed = true;
  phoneInfos: { model: string, imei: string }[] = [];
  public submitted = false;

  constructor(
    public readonly translate: TranslateService,
    private readonly phoneService: PhoneService,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
  }


  checkImei() {
    this.spinner.show();
    this.imei?.value?.split(' ').forEach(imei => {
      this.phoneService.checkImei(imei).subscribe(({ object }: any) => {
        this.spinner.hide();
        this.phoneInfos.push({ model: object?.model, imei });
        this.collapsed = false;
        console.log('Serial = ' + object?.serial + ' ' + ' Model = ' + object?.model + '<br>')
      });
    });
  }

}
